module.exports = __webpack_public_path__ + "img/pills.09a29b43.svg";